/* eslint-disable */
import { transliterate as tr } from "transliteration";
var slugify = require("slugify");

export const convertToUnAccent = (text: string | undefined | null) => {
  if (text) {
    return slugify(tr(text), {
      lower: true, // convert to lower case, defaults to false
      strict: false, // strip special characters except replacement, defaults to false
      locale: "en", // language code of the locale to use
      trim: true, // trim leading and trailing replacement chars, defaults to true
      replacement: " ",
    });
  }
  return null;
};
